import {
    allowScreenCaptureAsync,
    preventScreenCaptureAsync,
} from "expo-screen-capture";
import { useEffect } from "react";
import { Platform } from "react-native";

const BIOMETRIC_SCREEN_CAPTURE_KEY = "biometric-lock";

/**
 * Toggles Android FLAG_SECURE while biometric app lock is enabled.
 * Reacts to runtime changes (e.g. user toggling the setting) and releases
 * the flag on cleanup when the hook owner unmounts or `enabled` becomes false.
 */
export function useBiometricScreenCaptureProtection(enabled: boolean) {
    useEffect(() => {
        if (Platform.OS !== "android") {
            return;
        }

        if (enabled) {
            preventScreenCaptureAsync(BIOMETRIC_SCREEN_CAPTURE_KEY).catch(
                () => undefined,
            );
        } else {
            allowScreenCaptureAsync(BIOMETRIC_SCREEN_CAPTURE_KEY).catch(
                () => undefined,
            );
        }

        return () => {
            allowScreenCaptureAsync(BIOMETRIC_SCREEN_CAPTURE_KEY).catch(
                () => undefined,
            );
        };
    }, [enabled]);
}
